import { render, staticRenderFns } from "./ArchivoCPage.vue?vue&type=template&id=6aeda8f8"
import script from "./ArchivoCPage.js?vue&type=script&lang=js&external"
export * from "./ArchivoCPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports